import request from '@/utils/request'

//我的收藏
export function collectionList(data) {
	return request({
		url: '/api/sysUserCollection/collectionList',
		method: 'get',
		params: data
	})
}
//添加收藏
export function collectionSave(data) {
	return request({
		url: '/api/sysUserCollection/collectionSave',
		method: 'post',
		data
	})
}
//取消收藏
export function collectionDelete(data) {
	return request({
		url: '/api/sysUserCollection/collectionDelete',
		method: 'post',
		data
	})
}

//查看我的收藏详情
export function collectionDetail(data) {
	return request({
		url: '/api/sysUserCollection/getDetails',
		method: 'get',
		params: data
	})
}
